import React from "react";
import { Dropdown } from "antd";
import { GlobalOutlined } from "@ant-design/icons";
import type { MenuProps } from "antd";
import { languagesList } from "../../config/locales";
import emit from "@/utils/emit";

import styles from "./Language.module.scss";

const Language = (props) => {
  const { dom } = props;

  const arr = languagesList.map((item) => {
    return { label: item.title, key: item.value };
  });
  const items: MenuProps["items"] = arr;

  return (
    <div>
      <Dropdown
        menu={{
          items,
          onClick: (e) => {
            e.domEvent.stopPropagation();
            emit.emit("change_language", e.key);
          },
        }}
        trigger={["click"]}
      >
        {dom || <GlobalOutlined className={styles.langIcon} />}
      </Dropdown>
    </div>
  );
};
export default Language;
